import cl from "clsx";
import React, { useEffect, useState } from "react";
import { BodyShort } from "../typography";
import debounce from "../util/debounce";
const TextareaCounter = ({ maxLength, currentLength, size, i18n }) => {
    const difference = maxLength - currentLength;
    const [debouncedDiff, setDebouncedDiff] = useState(difference);
    useEffect(() => {
        const debounceFunc = debounce(() => {
            setDebouncedDiff(difference);
        }, 2000);
        debounceFunc();
        return () => {
            debounceFunc.clear();
        };
    }, [difference]);
    return (React.createElement(React.Fragment, null,
        difference < 20 && (React.createElement("span", { role: "status", className: "navds-textarea__sr-counter navds-sr-only" }, getCounterText(debouncedDiff, i18n))),
        React.createElement(BodyShort, { className: cl("navds-textarea__counter", {
                "navds-textarea__counter--error": difference < 0,
            }), size: size }, getCounterText(difference, i18n))));
};
const getCounterText = (difference, i18n) => {
    var _a, _b;
    return difference < 0
        ? `${Math.abs(difference)} ${(_a = i18n === null || i18n === void 0 ? void 0 : i18n.counterTooMuch) !== null && _a !== void 0 ? _a : "tegn for mye"}`
        : `${difference} ${(_b = i18n === null || i18n === void 0 ? void 0 : i18n.counterLeft) !== null && _b !== void 0 ? _b : "tegn igjen"}`;
};
export default TextareaCounter;
//# sourceMappingURL=TextareaCounter.js.map